import React from 'react'

import IconSvgContainer, { Props as IconSvgContainerProps } from './IconSvgContainer'

export type Props = IconSvgContainerProps

const IconSuccess: React.FC = (props: Props) => (
    <IconSvgContainer width="60" height="60" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M46.2517 20.02L24.9283 41.3435L19.3239 35.7299L20.02 35.035L24.9289 39.9519L45.5562 19.3245L46.2517 20.02ZM17.6329 34.0361L13.9141 30.3112L14.6101 29.6162L18.3289 33.3411L17.6329 34.0361Z"
            fill="#006C5C"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30 0.983607C13.9747 0.983607 0.983607 13.9747 0.983607 30C0.983607 46.0253 13.9747 59.0164 30 59.0164C46.0253 59.0164 59.0164 46.0253 59.0164 30C59.0164 13.9747 46.0253 0.983607 30 0.983607ZM0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z"
            fill="#006C5C"
        />
    </IconSvgContainer>
)

export default IconSuccess
